import { motion } from "framer-motion";
import "../styles/aboutPage.css";
import OurVision from "../components/OurVision";

export default function About() {
    return (
        <><section className="about-split-section" style={{ backgroundImage: `url(/images/about-bg.png)` }}>
            <div className="about-overlay"></div>

            <motion.div
                className="about-text-area"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
            >
                <span className="about-tag">ABOUT US</span>

                <h2 className="section-heading">Gulmohar Pulses</h2>
                <p className="about-sub section-heading ">
                    by Rajbharti Quartzite Industries Pvt. Ltd.
                </p>

                <p>
                    Rajbharti Quartzite Industries Pvt. Ltd., established in 2016,
                    is a pulses processing and packaging company committed to
                    providing high-quality, nutritious pulses to consumers and
                    businesses across the region.
                </p>

                <p>
                    With a strong focus on sustainable practices and advanced
                    processing technologies, Gulmohar Pulses ensures purity,
                    freshness, and food safety at every stage — from sourcing raw
                    materials to final packaging.
                </p>
            </motion.div>
        </section>
            <div className="section-divider curve-divider">
                <svg viewBox="0 0 1440 90" preserveAspectRatio="none">
                    <path
                        d="M0,40 C240,80 480,0 720,20 960,40 1200,60 1440,30 L1440,0 L0,0 Z"
                        fill="#fff2e0"
                    />
                </svg>
            </div>
            <OurVision />
            <section className="capabilities-section">
                <h3 className="capabilities-title section-heading">Our Capabilities</h3>
                <motion.div
                    className="capability-card"
                    initial={{ opacity: 0, x: -80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <div className="capability-image">
                        <img src="/images/processing.png" alt="Advanced Processing" style={{ background: "#fff2e0" }} />
                    </div>

                    <div className="capability-content">
                        <h4 className="section-heading">Advanced Processing</h4>

                        <p>
                            We use modern machinery and hygienic processes to ensure
                            uniform cleaning, grading, and polishing of pulses.
                        </p>

                        <div className="capacity-badge">
                            <span className="capacity-number">20</span>
                            <span className="capacity-text">
                                Tons / Day<br />
                                Processing Capacity
                            </span>
                        </div>
                    </div>
                </motion.div>
                <motion.div
                    className="capability-card reverse"
                    initial={{ opacity: 0, x: 80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <div className="capability-image">
                        <img src="/images/quality.png" alt="Quality Control" style={{ background: "#fff2e0" }} />
                    </div>

                    <div className="capability-content">
                        <h4 className="section-heading">Quality Control</h4>

                        <p>
                            Each batch undergoes strict quality checks to ensure purity,
                            safety, consistency, and freshness at every stage.
                        </p>

                        <ul className="quality-points">
                            <li><strong>Raw Material Inspection:</strong> Reliable sourcing with full traceability.</li>
                            <li><strong>Visual & Physical Checks:</strong> Foreign matter, size & colour consistency.</li>
                            <li><strong>Laboratory Testing:</strong> Moisture, pesticide & heavy metal testing.</li>
                            <li><strong>Processing Controls:</strong> Controlled cleaning & polishing.</li>
                            <li><strong>Hygiene & Safety:</strong> Sanitized facility & pest control.</li>
                            <li><strong>Moisture Control:</strong> Shelf-life & freshness management.</li>
                        </ul>
                    </div>
                </motion.div>
                <motion.div
                    className="capability-card"
                    initial={{ opacity: 0, x: -80 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <div className="capability-image">
                        <img src="/images/packaging.png" alt="Modern Packaging" style={{ background: "#fff2e0" }} />
                    </div>

                    <div className="capability-content">
                        <h4 className="section-heading">Modern Packaging</h4>

                        <p>
                            We provide durable, attractive, and food-grade packaging
                            solutions suitable for bulk and retail markets.
                        </p>

                        <ul className="packaging-checks">
                            <li>Sealing & labeling verification</li>
                            <li>Packaging integrity to prevent contamination</li>
                            <li>Accurate weight verification</li>
                        </ul>
                    </div>
                </motion.div>
            </section>
            <section className="clients-section">
                <div className="clients-inner">

                    <div className="clients-header">
                        <span className="clients-tag">OUR CLIENTS</span>
                        <h2 className="section-heading">Who We Serve</h2>
                    </div>

                    <div className="clients-grid">
                        <div className="client-card">
                            <span className="client-icon">🏬</span>
                            <h4>Wholesalers</h4>
                            <p>Bulk supply to regional and national wholesale markets.</p>
                        </div>

                        <div className="client-card">
                            <span className="client-icon">🍽️</span>
                            <h4>Food Service Companies</h4>
                            <p>Reliable sourcing for hotels, restaurants, and caterers.</p>
                        </div>

                        <div className="client-card">
                            <span className="client-icon">🌍</span>
                            <h4>Export Markets</h4>
                            <p>Quality pulses supplied to international buyers.</p>
                        </div>

                        <div className="client-card">
                            <span className="client-icon">📦</span>
                            <h4>Traders</h4>
                            <p>Consistent quality and volume for trading partners.</p>
                        </div>
                    </div>

                </div>
            </section>

            <section className="commitment-section">
                <div className="commitment-inner">
                    <div className="commitment-left">
                        <span className="commitment-tag">OUR COMMITMENT</span>
                        <h2 className="section-heading">
                            Quality & Sustainability
                        </h2>

                        <p>
                            We are committed to delivering safe, nutritious, and high-quality
                            pulses while operating responsibly and sustainably at every stage
                            of production.
                        </p>
                    </div>

                    <div className="commitment-right">
                        <ul className="commitment-list">
                            <li>
                                <strong>FSSAI License No:</strong> 11425510000006
                            </li>
                            <li>
                                Strict quality control from raw material sourcing to final packaging.
                            </li>
                            <li>
                                Sustainable practices to minimize environmental impact.
                            </li>
                            <li>
                                Full compliance with food safety standards and regulations.
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
        </>
    );
}
